import { apiClient } from './apiClient';

export interface SetupScore {
  score: number;
  checks: Record<string, boolean>;
  aiAnalysis?: string;
}

interface SetupScoreRaw {
  score: number;
  checks: Record<string, boolean>;
  ai_analysis?: string;
}

function mapRaw(raw: SetupScoreRaw): SetupScore {
  return {
    score: raw.score,
    checks: raw.checks,
    aiAnalysis: raw.ai_analysis,
  };
}

export const setupScoreService = {
  async getScore(spaceId: string): Promise<SetupScore> {
    const response = await apiClient.get<SetupScoreRaw>(`/setup-score/${spaceId}`);
    return mapRaw(response.data);
  },

  async analyzeSetup(spaceId: string): Promise<SetupScore> {
    const response = await apiClient.post<SetupScoreRaw>(`/setup-score/${spaceId}/analyze`);
    return mapRaw(response.data);
  },
};
